<template>
  <div>
    <thux-table
      :instance="instance"
      :instance-name="instanceName"
      :order-by-dict="orderByDict"
      :goBack="goBack"
      :list="list"
      :fieldName="fieldName"
      :fields="fields"
      :fields-column="fieldsColumn"
      :select-all="selectAll"
      :selected-list="selectedList"
      :get-local-selected-all="getLocalSelectedAll"
      :local-selected-list="localSelectedList"
      @check-all="checkAll"
      @check-none="checkNone"
      @set-selected-row="setSelectedRow"
      :show-checks="showChecks"
      :showEditButton="showEditButton"
      @change-status="changeInstanceStatus"
      @sort-changed="orderTable"
      @remove-order-by="removeOrderFromTable"
    >
      <template slot="not_required" slot-scope="row">
        <span
          :class="{ 'cursor-pointer': canToggleNotRequired(row.item) }"
          :title="notRequiredTitle(row.item)"
          @click="canToggleNotRequired(row.item) && toggleNotRequired(row.item)"
        >
          <status-indicator :status="!row.item.not_required_config_id" />
        </span>
      </template>
      <template slot="status_name" slot-scope="row">
        <div class="mt-3 f-w-600 d-flex justify-content-start">
        <document-status-popover
          v-if="row.item.attachment"
          :open-popover="
            instance &&
            row.item.id === instance.id &&
            showPopoverDocStatusModal"
          :field-name="$t('Status')"
          :id="row.item.id"
          :instance="row.item"
          :there-are-fields="row.item.status"
          :doc-status="row.item.status"
          :doc-status-name="row.item.status_name"
          :doc-validation-note="row.item.validation_note"
          :btn-title="$t('Change status')"
          @show-popover-modal="showPopoverDocumentStatus(row.item)"
          @close="reset()"
          @change-status="changeUploadDocumentStatus($event)"
        />
        <span v-else  :class="`fw-600 tag tag-${DOCUMENT_UPLOADDOCUMENT_STATUS_COLORS[row.item.status]}`">
          {{row.item.status_name}}
        </span>
        <span v-if="row.item.validation_note && row.item.status === 'P'">
          <v-popover
            offset="16"
            trigger="hover"
            placement="top"
            :auto-hide="true"
          >
            <slot name="body">
              <i class="fas fa-comment"></i>
            </slot>
            <template slot="popover">
                {{row.item.validation_note}}
            </template>
          </v-popover>
          <!-- <i class="fas fa-comment" :title="row.item.validation_note"></i> -->
          </span>
        </div>
      </template>

      <template slot="date_start" slot-scope="row">
          {{ row.item.date_start | date}}
      </template>

      <template slot="organization__name" slot-scope="row">
          <span v-if="!yardId"> {{ row.item.organization_name }}</span>
          <span v-else> {{ row.item.organization_typology_name ? `${row.item.organization_name} (${row.item.organization_typology_name})`: row.item.organization_name }}</span>
      </template>

      <template slot="date_end" slot-scope="row">
          <span :class="row.item.is_document_expired ? 'text-red' : ''">
            {{ row.item.date_end | date}}
          </span>
      </template>

      <template slot="yards" slot-scope="row">
        {{row.item.yard_name_short_list}}
      </template>

      <template slot="other-buttons-actions-bottom" slot-scope="row">
        <b-btn v-if="row.item.is_downloadable || row.item.is_created_by_template"
          variant="outline-primary"
          v-has-perms="downloadModelRolePerm"
          :title="'Download model' | translate"
          @click="generateDocument(row.item)"
        >
          <i class="fas fa-file-download"></i>
        </b-btn>
        <b-btn v-if="!row.item.attachment && !row.item.is_dpi_document"
          variant="outline-primary"
          v-has-perms="uploadCopyRolePerm"
          :title="'Upload copy' | translate"
          :disabled="(yardDetail && yardDetail.is_active === false) || (row.item.valid_links.length > 0 && !row.item.has_active_yards)"
          @click.prevent="$emit('open-edit-form', {id: row.item.id})"
        >
          <i class="fas fa-upload"></i>
        </b-btn>
        <b-btn v-if="row.item.attachment && !row.item.is_dpi_document"
          variant="outline-primary"
          v-has-perms="uploadCopyRolePerm"
          :title="'Upload copy' | translate"
          :disabled="(yardDetail && yardDetail.is_active === false) || (row.item.valid_links.length > 0 && !row.item.has_active_yards)"
          @click.prevent="updateDocumentRequest(row.item)"
        >
          <i class="fas fa-upload"></i>
        </b-btn>
        <b-btn v-if="row.item.attachment"
          variant="outline-primary"
          v-has-perms="downloadDocRolePerm"
          :title="'download' | translate"
          @click="downloadDocument(row.item)"
        >
          <i class="fas fa-download"></i>
        </b-btn>
        <b-btn
          v-if='orgId && !cntId'
          variant="outline-primary"
          :title="'Show yards' | translate"
          @click="showYardModal(row.item)"
        >
          <i class="fas fa-building"></i>
        </b-btn>
        <b-btn
          variant="outline-primary"
          v-has-perms="showHistoryRolePerm"
          :title="'Show history' | translate"
          @click="showHistoryModal(row.item)"
        >
          <i class="fas fa-history"></i>
        </b-btn>
        <b-btn
          variant="outline-primary"
          v-has-perms="editRolePerm"
          :title="'Edit data' | translate"
          @click="showEditDataForm(row.item)"
        >
          <i class="fas fa-edit"></i>
        </b-btn>
        <b-btn
          v-if="!me.profiles.includes('backoffice')"
          variant="outline-primary"
          v-has-perms="deleteRolePerm"
          :title="'Delete' | translate"
          @click="openDeleteModal(row.item)"
        >
          <i class="far fa-trash-alt"></i>
        </b-btn>
      </template>
    </thux-table>
    <upload-document-modal
      v-if="showUploadDocumentModal"
      :yard-document-id="modalItem.id"
      :doc-item="modalItem"
      :title="$t('Upload document')"
      @close="closeModal"
    />
    <document-history-modal
      v-if="showUploadDocumentHistoryModal"
      :upload-document-id="modalItem.id"
      :upload-document-name="modalItem.document_name"
      :upload-organization-name="modalItem.organization_name"
      :title="$t('Upload document')"
      @close="closeModal"
    />
    <document-yard-modal
      v-if="showUploadDocumentYardModal"
      :upload-document-id="modalItem.id"
      :upload-document-name="modalItem.document_name"
      :upload-organization-name="modalItem.organization_name"
      :title="$t('Upload document')"
      @close="closeModal"
    />
    <ConfirmDialog
      v-if="showWarningModal && docToDuplicate"
      ref-id="modal-confirm"
      :no-close-on-backdrop="true"
      content-class="attachment-modal"
      confirm-btn-variant="primary"
      :title="$t('WARNING')"
      :button-confirm-text="'Continue' | translate"
      @confirm-dialog-close="closeWarningModal"
      @confirm-dialog-select="duplicateDocument"
    >
      <template slot="body">
        {{warningModalMsg}}
      </template>
    </ConfirmDialog>
    <ConfirmDialog
      v-if="showDeleteModal && docToDelete"
      ref-id="modal-delete"
      :no-close-on-backdrop="true"
      content-class="attachment-modal"
      confirm-btn-variant="primary"
      :title="$t('WARNING')"
      :button-confirm-text="'Continue' | translate"
      @confirm-dialog-close="closeDeleteModal"
      @confirm-dialog-select="deleteDocument"
    >
      <template slot="body">
        <h4> {{$t('Deleting the document is a non-reversible operation')}}</h4>
        {{deleteModalMsg}}
      </template>
    </ConfirmDialog>
    <WarningDialog
      v-if="showWarningDialog"
      ref-id="modal-warning"
      :no-close-on-backdrop="true"
      confirm-btn-variant="primary"
      :confirm-btn-disabled="false"
      :title="$t('WARNING')"
      :body="warningDialogMessage"
      :button-confirm-text="'OK' | translate"
      @warning-dialog-close="closeWarningDialogModal"
    >
    </WarningDialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as AUTH_TYPES } from '@/pages/auth/store'
import { TYPES as DOCUMENT_TYPES } from '../document/store'
import { TYPES as UPLOAD_DOCUMENT_TYPES } from './store'
import { TYPES as DOCUMENT_YARD_LINK_TYPES } from '../document-yard-link/store'

import ThuxTableMixin from '@/components/thux-table/ThuxTableMixin'
import ThuxTableChecksMixin from '@/components/thux-table/thux-table-checks/ThuxTableChecksMixin'
import StatusIndicator from '@/components/StatusIndicator'
import UploadDocumentHistoryModal from './history/UploadDocumentHistoryModal'
import UploadDocumentYardModal from './yard/UploadDocumentYardModal'
import UploadDocumentModal from './UploadDocumentModal.vue'
import { DOCUMENT_UPLOADDOCUMENT_STATUS_COLORS } from '@/const'
import ConfirmDialog from '@/components/ConfirmDialog'
import WarningDialog from '@/components/WarningDialog'
import UploadDocumentStatusFieldPopover from '@/pages/document/components/UploadDocumentStatusFieldPopover'
import { hasPerm } from '@/components/PermissionHelper'

export default {
  name: 'UploadDocumentsTable',
  mixins: [ThuxTableMixin, ThuxTableChecksMixin],
  props: {
    yardDetail: {}
  },
  components: {
    UploadDocumentModal,
    StatusIndicator,
    ConfirmDialog,
    WarningDialog,
    'document-status-popover': UploadDocumentStatusFieldPopover,
    'document-history-modal': UploadDocumentHistoryModal,
    'document-yard-modal': UploadDocumentYardModal
  },
  data () {
    const fields = [
      {
        key: 'status_name',
        label: this.$t('Status'),
        tdClass: 'text-nowrap',
        thClass: 'text-nowrap',
        custom: true
      },
      {
        key: 'not_required',
        label: this.$t('Necessary'),
        tdClass: 'text-nowrap',
        thClass: 'text-nowrap',
        sortable: false,
        custom: true
      },
      {
        key: 'document__name',
        label: this.$t('Name'),
        type: 'text',
        thClass: 'text-nowrap',
        tdClass: 'text-wrap',
        sortable: true,
        value: 'document_name'
      },
      {
        key: 'organization__name',
        label: this.$t('Organization'),
        thClass: 'text-nowrap',
        tdClass: 'text-wrap',
        sortable: true,
        value: 'organization_name',
        custom: true
      },
      {
        key: 'date_start',
        label: this.$t('Validity start'),
        type: 'text',
        thClass: 'text-nowrap',
        tdClass: 'text-nowrap',
        sortable: true,
        custom: true
      },
      {
        key: 'date_end',
        label: this.$t('Validity end'),
        type: 'text',
        thClass: 'text-nowrap',
        tdClass: 'text-nowrap',
        sortable: true,
        custom: true
      },
      {
        key: 'note',
        label: this.$t('Note'),
        type: 'text',
        thClass: 'text-nowrap',
        tdClass: 'text-wrap',
        sortable: false,
        value: 'note'
      },
      {
        key: 'action',
        label: this.$t('Actions'),
        tdClass: 'text-right text-nowrap',
        thClass: 'text-right text-nowrap'
      }
    ]
    return {
      modalItem: null,
      showUploadDocumentModal: false,
      showUploadDocumentHistoryModal: false,
      showUploadDocumentYardModal: false,
      orgId: this.$route.params.orgId,
      cntId: this.$route.params.cntId,
      fields: fields,
      fieldsColumn: ['status', 'status_name', 'document_name', 'organization__name', 'date_start', 'date_end'],
      showPopoverDocStatusModal: false,
      instance: undefined,
      DOCUMENT_UPLOADDOCUMENT_STATUS_COLORS,
      docToDuplicate: undefined,
      showWarningModal: false,
      docToDelete: undefined,
      showDeleteModal: false,
      showWarningDialog: false,
      deleteModalMsg: this.$t(''),
      warningDialogMessage: '',
      warningModalMsg: this.$t('The selected document already has a linked file. By continuing with this operation, the existing document will be indicated as outdated and a new version will be created to which a new file will be attached.'),
      // Permissions
      downloadModelRolePerm: 'document_document_download_file',
      downloadDocRolePerm: 'document_uploaddocument_download_attachment',
      editRolePerm: 'document_uploaddocument_update',
      deleteRolePerm: 'document_uploaddocument_destroy',
      showHistoryRolePerm: 'document_uploaddocument_history',
      uploadCopyRolePerm: 'document_uploaddocument_update',
      setNotRequiredRolePerm: 'document_documentworkerconfig_create',
      unsetNotRequiredRolePerm: 'document_documentworkerconfig_destroy'
    }
  },
  created () {
    if (this.$route.params.orgId && !this.$route.params.cntId) {
      this.fields.splice(6, 0, {
        key: 'yards',
        label: this.$t('Yards'),
        type: 'text',
        thClass: 'text-nowrap',
        tdClass: 'text-nowrap',
        sortable: false,
        custom: true
      })
      this.fields.splice(3, 1)
    }
    // The "Necessary" column is per-worker: show it only when a contact (cntId) is selected.
    if (!this.$route.params.cntId) {
      const idx = this.fields.findIndex((f) => f.key === 'not_required')
      if (idx !== -1) this.fields.splice(idx, 1)
    }
  },
  computed: {
    ...mapGetters({
      me: AUTH_TYPES.AUTH.me,
      selectAll: UPLOAD_DOCUMENT_TYPES.GENERIC.document.uploaddocument.LIST.GETTERS.selectAll,
      detail: UPLOAD_DOCUMENT_TYPES.GENERIC.document.uploaddocument.DETAIL.GETTERS.update,
      selectedList: UPLOAD_DOCUMENT_TYPES.GENERIC.document.uploaddocument.LIST.GETTERS.selectedList
    }),
    showChecks () {
      return false
    },
    showDetailButton () {
      return false
    },
    showEditButton () {
      return false
    },
    yardId () {
      return this.$route.params.yardId
    }
  },
  methods: {
    ...mapMutations({
      setList: UPLOAD_DOCUMENT_TYPES.GENERIC.document.uploaddocument.LIST.MUTATIONS.setList,
      setSelectedList: UPLOAD_DOCUMENT_TYPES.GENERIC.document.uploaddocument.LIST.MUTATIONS.setSelectedList,
      setSelectAll: UPLOAD_DOCUMENT_TYPES.GENERIC.document.uploaddocument.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...UPLOAD_DOCUMENT_TYPES.GENERIC.document.uploaddocument.LIST.ACTIONS,
      update: UPLOAD_DOCUMENT_TYPES.GENERIC.document.uploaddocument.DETAIL.ACTIONS.update,
      delete: UPLOAD_DOCUMENT_TYPES.GENERIC.document.uploaddocument.DETAIL.ACTIONS.delete,
      partialUpdate: UPLOAD_DOCUMENT_TYPES.GENERIC.document.uploaddocument.DETAIL.ACTIONS.partialUpdate,
      duplicate: UPLOAD_DOCUMENT_TYPES.GENERIC.document.uploaddocument.DETAIL.ACTIONS.duplicate,
      printDocumentPdf: DOCUMENT_YARD_LINK_TYPES.GENERIC.document.documentyardlink.DETAIL.ACTIONS.download,
      downloadModel: DOCUMENT_TYPES.GENERIC.document.document.DETAIL.ACTIONS.download
    }),
    showHistoryModal (item) {
      this.$set(this, 'modalItem', item)
      this.$set(this, 'showUploadDocumentHistoryModal', true)
      this.$set(this, 'showUploadDocumentModal', false)
      this.$set(this, 'showUploadDocumentYardModal', false)
    },
    showYardModal (item) {
      this.$set(this, 'modalItem', item)
      this.$set(this, 'showUploadDocumentYardModal', true)
      this.$set(this, 'showUploadDocumentHistoryModal', false)
      this.$set(this, 'showUploadDocumentModal', false)
    },
    closeModal () {
      this.$set(this, 'modalItem', null)
      this.$set(this, 'showUploadDocumentModal', false)
      this.$set(this, 'showUploadDocumentHistoryModal', false)
      this.$set(this, 'showUploadDocumentYardModal', false)
    },
    removeOrderFromTable (orderBy) {
      delete this.orderByDict[orderBy]
      const orderByListString = Object.values(this.orderByDict).map(
        value => `${value.sortDesc ? '-' : ''}${value.orderBy}`
      )
      let index = 1
      Object.keys(this.orderByDict).forEach((key) => {
        this.orderByDict[key].index = index
        index += 1
      })
      if (orderByListString.length === 0) {
        orderByListString.push('document__name')
      }
      this.changeOrderBy(orderByListString.join('.'))
    },
    downloadDocument (item) {
      const fileName = `${item.document_name}.${item.attachment_simple_filename.split('.').pop()}`
      this.download({ id: item.id, action: 'download-attachment', simpleFileName: fileName })
    },
    generateDocument (item) {
      if (item.is_created_by_template) {
        const yardLink = item.valid_links.find(x => x.yard === parseInt(this.yardId))
        this.printDocumentPdf({ id: yardLink.id, action: 'print-pdf', simpleFileName: `${item.document_name}.pdf` })
      } else {
        this.downloadModel({ id: item.document, action: 'download-document', simpleFileName: item.document_simple_filename })
      }
    },
    showPopoverDocumentStatus (uploadDocument) {
      this.$set(this, 'instance', uploadDocument)
      this.$set(this, 'showPopoverDocStatusModal', true)
    },
    reset () {
      this.$set(this, 'instance', {})
      this.$set(this, 'showPopoverDocStatusModal', false)
    },
    changeUploadDocumentStatus (evt) {
      const formData = { id: this.instance.id, ...evt }
      this.partialUpdate(formData).then(
        () => {
          this.$set(this, 'instance', {})
          this.$set(this, 'showPopoverDocStatusModal', false)
        }
      )
    },
    updateDocumentRequest (uploadDocument) {
      this.$set(this, 'docToDuplicate', uploadDocument.id)
      this.$set(this, 'showWarningModal', true)
    },
    closeWarningModal () {
      this.$set(this, 'docToDuplicate', undefined)
      this.$set(this, 'showWarningModal', false)
    },
    duplicateDocument () {
      this.duplicate({ id: this.docToDuplicate, yardId: this.yardId }).then(
        (item) => {
          this.$emit('open-edit-form', { id: item.id })
        }
      )
      this.closeWarningModal()
    },
    showEditDataForm (uploadDocument) {
      this.$emit('open-edit-form', { id: uploadDocument.id, onlyData: true })
    },
    canToggleNotRequired (uploadDocument) {
      // The "no longer required" flag is a (worker, document) DocumentWorkerConfig:
      // it only makes sense when the document belongs to a worker.
      return !!uploadDocument.worker && (
        uploadDocument.not_required_config_id
          ? hasPerm(this.unsetNotRequiredRolePerm)
          : hasPerm(this.setNotRequiredRolePerm)
      )
    },
    notRequiredTitle (uploadDocument) {
      return uploadDocument.not_required_config_id ? this.$t('No longer required') : this.$t('Necessary')
    },
    toggleNotRequired (uploadDocument) {
      const action = uploadDocument.not_required_config_id
        ? this.unsetNotRequired(uploadDocument.not_required_config_id)
        : this.setNotRequired({ worker: uploadDocument.worker, document: uploadDocument.document })
      action.then(() => {
        this.$emit('refresh-list')
      })
    },
    openDeleteModal (uploadDocument) {
      if (uploadDocument.is_passed) {
        this.$set(this, 'docToDuplicate', undefined)
        this.$set(this, 'showWarningDialog', true)
        const msg = 'Unable to delete the document. A more recent version of the selected document is present in the system.'
        this.$set(this, 'warningDialogMessage', msg)
      } else {
        this.$set(this, 'docToDuplicate', undefined)
        this.$set(this, 'showWarningModal', false)
        this.$set(this, 'docToDelete', uploadDocument.id)
        this.$set(this, 'showDeleteModal', true)
        const msg = `${this.$t('Do you want to proceed with the elimination of document')} ${uploadDocument.document_name}?`
        this.$set(this, 'deleteModalMsg', msg)
      }
    },
    closeWarningDialogModal () {
      this.$set(this, 'docToDelete', undefined)
      this.$set(this, 'showWarningDialog', false)
    },
    closeDeleteModal () {
      this.$set(this, 'docToDelete', undefined)
      this.$set(this, 'showDeleteModal', false)
    },
    deleteDocument () {
      this.delete({ id: this.docToDelete }).then(
        () => {
          this.closeDeleteModal()
        }
      )
    }
  }
}
</script>
